import { render } from "./Education.vue?vue&type=template&id=569da790"
import script from "./Education.vue?vue&type=script&lang=js"
export * from "./Education.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Samson5\\Scripts\\CVue-Awesome\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__